import { PaymentState } from "@/data/model/Enums";

import { i18n } from "@/portal/Trans";

export class PaymentStateBadge {
    public static renderTo($parent: JQuery, paymentState: PaymentState) {
        $(this.render(paymentState)).appendTo($parent);
    }

    public static render(paymentState: PaymentState) {
        const state = PaymentState[paymentState];
        return `<span class="payment-state-badge payment-state-${state.toLowerCase()}">${i18n("enums.PaymentState." + state)}</span>`;
    }
}
